import IMAGE_SIZES from "../imageSizes.json";

const fileName = (src) => decodeURIComponent((src || "").split("?")[0].split("/").pop() || "");

const humanize = (src) => fileName(src).replace(/\.[a-z0-9]+$/i, "").replace(/\(\d+\)/g, "").replace(/[-_]+/g, " ").replace(/\d+$/, "").replace(/\s+/g, " ").trim();

export const clipAlt = (alt) => (alt && alt.length > 100 ? alt.slice(0, 101).replace(/\s+\S*$/, "") : alt || "");

const fixHref = (a) => {
  let href = a.getAttribute("href");
  const internal = /^https?:\/\/(www\.)?lazydayshome\.com/i.test(href) || href.startsWith("/");
  if (internal) {
    href = href.replace(/^https?:\/\/(www\.)?lazydayshome\.com/i, "").replace(/\.html?$/i, "") || "/";
    a.setAttribute("href", href);
  }
  if (a.getAttribute("target") === "_blank" && !/noopener/.test(a.getAttribute("rel") || "")) a.setAttribute("rel", "noopener noreferrer");
};

// Normalises CMS/blog HTML: one H1 per page, sized/alt-tagged images, safe links, no legacy .html links.
export function cleanHtml(html, { fallbackAlt = "" } = {}) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  doc.querySelectorAll("h1").forEach((h) => {
    const h2 = doc.createElement("h2");
    [...h.attributes].forEach((at) => h2.setAttribute(at.name, at.value));
    h2.innerHTML = h.innerHTML;
    h.replaceWith(h2);
  });
  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");
    const size = IMAGE_SIZES[fileName(src).toLowerCase()];
    if (size && !img.getAttribute("width")) { img.setAttribute("width", size[0]); img.setAttribute("height", size[1]); }
    const alt = clipAlt((img.getAttribute("alt") || "").trim() || humanize(src) || fallbackAlt);
    img.setAttribute("alt", alt);
    if (!img.getAttribute("title")) img.setAttribute("title", alt);
    img.setAttribute("loading", "lazy");
  });
  doc.querySelectorAll("a[href]").forEach(fixHref);
  return doc.body.innerHTML;
}
